const DocsURL = "https://www.goambo.com/docs/"

export const Links = {
    signInPagePath: "sign-in",
    errorPagePath: "error",
    logoutPath: "/auth/logout",
    AdvocateSettingsPagePath: "/settings",
    AdvocatePostsPagePath: "/posts",
    AdvocatePendingApprovalPostsPagePath: "/posts?status=PENDING_APPROVAL",
    AdvocateCalendarPagePath: "/calendar",
    AdminPagePath: "/admin/",
    AdminSettingsPagePath: "/admin/settings",
    AdminPostsPagePath: "/admin/posts",
    AdminCalendarPagePath: "/admin/calendar",
    AdminChannelsPagePath: "/admin/channels",
    AdminCampaignsPagePath: "/admin/campaigns",
    AdminMediaPagePath: "/admin/media",
    DocsURL,
    AdminAnalyticsPagePath: "/admin/analytics",
    AdminUsersPagePath: "/admin/users",
    AdminPostAnalyticsPagePathPrefix: "/admin/analytics/posts/",
    AdminAdvocateAnalyticsPagePathPrefix: "/admin/analytics/advocates/",
    AdminSavePostPagePathPrefix: "/admin/posts/",
    AdminInspirationHubPagePath: "/admin/inspiration-hub",
    AdminCommentsPagePath: "/admin/comments",
    ExternalSharePostPagePathPrefix: "/s/",
    PublicCampaignPagePathPrefix: "/c/",
    AdvocateAnalyticsPagePath: "/analytics",
    AdvocateCommentsPagePath: "/comments",
}

// PageDocs maps app routes (and optionally query strings) to their doc page; more specific entries come first
export const PageDocs = [
    { pathPattern: /^\/admin\/posts\/(new|[^/]+\/edit)/, title: "Adding Media to Posts", slug: "admin-post-media" },
    { pathPattern: /^\/admin\/posts/, title: "Managing Posts and Content", slug: "admin-posts" },
    { pathPattern: /^\/admin\/calendar/, title: "Content Calendar", slug: "admin-calendar" },
    { pathPattern: /^\/admin\/media/, title: "Media Gallery", slug: "admin-media-gallery" },
    { pathPattern: /^\/admin\/inspiration-hub/, searchPattern: /source=SOCIAL_LISTENING/, title: "Social Listening for Inspiration", slug: "admin-social-listening" },
    { pathPattern: /^\/admin\/inspiration-hub/, title: "RSS Feeds and Automated Content", slug: "admin-rss-feeds" },
    { pathPattern: /^\/admin\/comments/, title: "Comments on LinkedIn Posts", slug: "admin-comments" },
    { pathPattern: /^\/admin\/settings/, title: "Organization Settings", slug: "admin-org-settings" },
    { pathPattern: /^\/admin\/channels/, title: "Channels and Content Distribution", slug: "admin-channels" },
    { pathPattern: /^\/admin\/campaigns/, title: "Campaigns", slug: "admin-campaigns" },
    { pathPattern: /^\/admin\/analytics/, title: "Analytics and Reporting", slug: "admin-analytics" },
    { pathPattern: /^\/admin\/users/, title: "Managing Users", slug: "admin-users" },
    { pathPattern: /^\/posts\/[^/]+\/approve/, title: "Approving Posts", slug: "advocate-browsing", anchor: "pending-approval" },
    { pathPattern: /^\/posts\/[^/]+\/share/, title: "Sharing Content to LinkedIn", slug: "advocate-sharing" },
    { pathPattern: /^\/social-media-shares\//, title: "Sharing Content to LinkedIn", slug: "advocate-sharing" },
    { pathPattern: /^\/posts\/?$/, title: "Browsing and Finding Content", slug: "advocate-browsing" },
    { pathPattern: /^\/calendars?(\/|$)/, title: "Your Calendar", slug: "advocate-calendar" },
    { pathPattern: /^\/analytics/, title: "Leaderboard", slug: "advocate-leaderboard" },
    { pathPattern: /^\/comments/, title: "Comments", slug: "admin-comments", anchor: "what-advocates-see" },
    { pathPattern: /^\/settings/, title: "Advocate Settings and Notifications", slug: "advocate-settings" },
]

export const LOAD_POSTS_LIMIT = 9
export const ADMIN_LOAD_POSTS_LIMIT = 9

export const POST_SOURCE_ORGANIC = "ORGANIC"
export const POST_SOURCE_FEED = "FEED"
export const POST_SOURCE_SOCIAL_LISTENING = "SOCIAL_LISTENING"

export const POST_STATUS_DRAFT = "DRAFT"
export const POST_STATUS_PUBLISHED = "PUBLISHED"
export const POST_STATUS_SCHEDULED = "SCHEDULED"
export const POST_STATUS_EXPIRED = "EXPIRED"
export const POST_STATUS_REJECTED = "REJECTED"

export const POST_VARIATION_PENDING_APPROVAL = "PENDING_APPROVAL"
export const POST_VARIATION_REJECTED = "REJECTED"
export const POST_VARIATION_APPROVED = "APPROVED"

export const POST_SHARE_STATUS_NEW = "NEW"
export const POST_SHARE_STATUS_SHARED = "SHARED"
export const POST_SHARE_STATUS_SCHEDULED = "SCHEDULED"
export const POST_SHARE_STATUS_PENDING_APPROVAL = "PENDING_APPROVAL"
export const POST_SHARE_STATUS_FAILED = "FAILED"

export const SOCIAL_MEDIA_SHARE_STATUS_SHARED = "SHARED"
export const SOCIAL_MEDIA_SHARE_STATUS_FAILED = "FAILED"
export const SOCIAL_MEDIA_SHARE_STATUS_PROCESSING = "PROCESSING"
export const SOCIAL_MEDIA_SHARE_STATUS_SCHEDULED = "SCHEDULED"
export const SOCIAL_MEDIA_SHARE_STATUS_OAUTH_PENDING = "OAUTH_PENDING"

export const NOW = "now"
export const NOW_MINUS_3_DAY = "now-3d"
export const NOW_MINUS_1_WEEK = "now-1w"
export const NOW_MINUS_1_MONTH = "now-1m"
export const NOW_MINUS_3_MONTH = "now-3m"
export const NOW_MINUS_6_MONTH = "now-6m"

export const CALENDAR_ITEM_STATUS = {
    SHARED: "SHARED",
    SCHEDULED: "SCHEDULED",
    PENDING_APPROVAL: "PENDING_APPROVAL",
    DRAFT: "DRAFT",
    FAILED: "FAILED",
}

export const CALENDAR_ACCESS_STATUS = {
    REQUESTED: "REQUESTED",
    GRANTED: "GRANTED",
    DECLINED: "DECLINED",
}

export const SHARE_TARGET = {
    ADVOCATE: "advocate",
    CHANNELS: "channels",
    COMPANY_PAGE: "company_page",
}

export const MEDIA_TYPE_IMAGE = "image"
export const MEDIA_TYPE_VIDEO = "video"
export const MEDIA_TYPE_PDF = "pdf"

export const AI_CONTENT_ADDITION_STRATEGY_APPEND = "APPEND"
export const AI_CONTENT_ADDITION_STRATEGY_REPLACE_CURRENT = "REPLACE_CURRENT"

export const CONTENT_MAX_LENGTH = 3000
export const COMMENT_MAX_LENGTH = 1250

export const COMMENT_TARGET_STATUS = {
    PENDING_APPROVAL: "PENDING_APPROVAL",
    SCHEDULED: "SCHEDULED",
    PROCESSING: "PROCESSING",
    COMMENTED: "COMMENTED",
    FAILED: "FAILED",
    REJECTED: "REJECTED",
}

export const POST_VARIATION_TYPE_POST = "post"
export const POST_VARIATION_TYPE_REPOST = "repost"


export const PUBLIC_CAMPAIGN_TAB = {
    NEW: "NEW",
    SHARED: "SHARED",
}
